export const useIsChatEnabled = () => true;